import React from 'react';
import { motion } from 'framer-motion';

const AboutMe = () => {
  return (
    <section id="about-me" className="bg-gradient-to-b from-gray-100 to-gray-200 text-black py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10"
        >
          <h2 className="text-4xl font-bold mb-4">About Me</h2>
          <p className="text-lg text-black">
            I am a passionate developer with expertise in building scalable and user-friendly web applications. 
            My journey in development has been driven by a love for solving problems, crafting engaging user 
            experiences, and staying at the cutting edge of technology. 
          </p>
        </motion.div>

        <div className="flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="w-full md:w-1/2 p-4 text-center"
          >
            <h3 className="text-2xl font-bold mb-4">Who I Am</h3>
            <p className="text-black leading-relaxed mb-6">
              With a strong foundation in front-end and back-end development, I enjoy creating web solutions 
              that not only meet user needs but exceed their expectations. I take pride in writing clean, 
              maintainable code and collaborating with teams to bring ideas to life.
            </p>
            <p className="text-black leading-relaxed">
              When I'm not coding, you can find me exploring new tech trends, contributing to open-source 
              projects, or sharing knowledge with the community. Let's connect and create something amazing together!
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="w-full md:w-1/2 p-4 text-center"
          >
           

             <h3 className="text-xl font-bold text-black mb-4">Skills & Expertise</h3>
            <ul className="list-disc list-inside text-black inline-block text-left">
              <li>Frontend Development - React, HTML, CSS, JavaScript, Nextjs, Tailwind</li> <br></br>
              <li>Backend Development - Node.js, Python, Flask, FastAPI</li> <br></br>
              <li>Database Management - PostgreSQL, SQL, SQLite</li> <br></br>
              <li>Version Control - Git, GitHub</li> <br></br>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;